import * as types from "../actions/actionsTypes";

let initialState = {
  open: true,
  cart: {},
  products: [],
  categories: {},
  address: null,
};

const storeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PRODUCTS:
      return {
        ...state,
        products: action.data
      };

    case types.SET_CATEGORIES:
      return {
        ...state,
        categories: action.data
      };

    case types.SET_CART:
      return {
        ...state,
        cart: action.data
      };

    case types.SET_OPEN:
      return {
        ...state,
        open: action.data
      };

    case types.RESET_STORE:
      return {
        open: true,
        cart: {},
        products: [],
        categories: {}
      };

    case types.SET_ADDRESS:
      return {
        ...state,
        address: { ...action.data },
      };

    case types.RESET_ADDRESS:
      return {
        ...state,
        address: null,
      };

    default:
      return state;
  }
};

export default storeReducer;
